// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2MyNY","actionsCol":"EnrolledClinics_actionsCol__29QtI"};